import React from "react";

interface CollectionItemProps {
    productId: string;
    productImageUrl: string;
    handleItemClick: (event: React.MouseEvent, productId: string) => void;
}

function CollectionItem({
    productId,
    productImageUrl,
    handleItemClick,
}: CollectionItemProps): JSX.Element {
    function handleClick(event: React.MouseEvent): void {
        handleItemClick(event, productId);
    }
    return (
        <button onClick={handleClick}>
            <img className="collectionItem" src={productImageUrl} alt={productId} />
        </button>
    );
}

export default CollectionItem;
